import React, {useCallback} from 'react';
import {useIntl} from 'react-intl';

import {useCustomerMgr, useProducts, useSetUI, useUI} from 'coreHooks';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';
import FlyoutToggleButton from 'brandComponents/flyouts/FlyoutToggleButton';
import {useHeaderCtx} from 'brandComponents/Header/HeaderCtx';
import Icon from 'brandComponents/Icon';
import {useWishlist} from 'brandHooks';

import messages from './messages';

const ButtonIcon = ({title, count}: {title: string; count: number}) => (
	<div className="wishlist-totals">
		<Icon name="wishlist-false" title={title} height={20} width={20} />
		{count > 0 && (
			<div className="wishlist-totals-items__count">
				<span>{count}</span>
			</div>
		)}
	</div>
);

const WishlistServiceMenuItem = () => {
	const {handleNavigationVisibility} = useHeaderCtx();
	const {managerRepository} = useGeneralProvider();
	const {isNavigationOpened} = useUI('header');
	const intl = useIntl();
	const CustomerMgr = useCustomerMgr();
	const customer = CustomerMgr.getCurrentCustomer();
	const setUI = useSetUI();
	const isWishlistEnabledNotAuth = managerRepository
		.getConfigurationsMgr()
		.get('sitePreferences.enableNotAuthenticatedCustomerWishlist');
	const {items} = useWishlist();
	const products = useProducts(items.map(i => i.productId));
	const wishlistProducts = products.filter(p => !p.isOffline());

	// Wishlist icon should open login flyout for guest users
	const openLoginFlyout = useCallback(() => {
		if (isNavigationOpened) {
			handleNavigationVisibility();
		}

		if (managerRepository.getFlyoutsMgr().isFlyoutOpened('login')) {
			return true;
		}

		setUI.setUI({isWishlistClick: true});
		managerRepository.getFlyoutsMgr().openFlyout('login', true);
	}, [isNavigationOpened]);

	const buttonIcon = <ButtonIcon title={intl.formatMessage(messages.wishlistBookmarkTitle)} count={wishlistProducts.length} />;

	return (
		<>
			{isWishlistEnabledNotAuth || customer.isRegistered ? (
				<FlyoutToggleButton buttonContent={buttonIcon} flyoutId="wishlist" />
			) : (
				<Button onClick={openLoginFlyout} variant="anything" >
					{buttonIcon}
				</Button>
			)}
		</>
	);
};

export default WishlistServiceMenuItem;
